// Auto-generated by scripts/generate-pg-keywords.js from PostgreSQL REL_17_STABLE kwlist.h, pl_reserved_kwlist.h,
// and pl_unreserved_kwlist.h. Do not edit by hand; re-run the script.

// Keywords that require double-quoting when used as an identifier in any
// context — everything categorized as RESERVED_KEYWORD,
// COL_NAME_KEYWORD, or TYPE_FUNC_NAME_KEYWORD in PostgreSQL's kwlist.h.
// COL_NAME_KEYWORD and TYPE_FUNC_NAME_KEYWORD each have positional
// restrictions (e.g. cannot be used as a type/function name, or as a
// column name, respectively); since lint rules visit identifier tokens
// without full positional context, treating these categories as "needs
// quoting" is the only cross-context-safe choice.
export const PG_KEYWORDS_REQUIRING_QUOTES: ReadonlySet<string> = new Set([
  "all",
  "analyse",
  "analyze",
  "and",
  "any",
  "array",
  "as",
  "asc",
  "asymmetric",
  "authorization",
  "between",
  "bigint",
  "binary",
  "bit",
  "boolean",
  "both",
  "case",
  "cast",
  "char",
  "character",
  "check",
  "coalesce",
  "collate",
  "collation",
  "column",
  "concurrently",
  "constraint",
  "create",
  "cross",
  "current_catalog",
  "current_date",
  "current_role",
  "current_schema",
  "current_time",
  "current_timestamp",
  "current_user",
  "dec",
  "decimal",
  "default",
  "deferrable",
  "desc",
  "distinct",
  "do",
  "else",
  "end",
  "except",
  "exists",
  "extract",
  "false",
  "fetch",
  "float",
  "for",
  "foreign",
  "freeze",
  "from",
  "full",
  "grant",
  "greatest",
  "group",
  "grouping",
  "having",
  "ilike",
  "in",
  "initially",
  "inner",
  "inout",
  "int",
  "integer",
  "intersect",
  "interval",
  "into",
  "is",
  "isnull",
  "join",
  "json",
  "json_array",
  "json_arrayagg",
  "json_exists",
  "json_object",
  "json_objectagg",
  "json_query",
  "json_scalar",
  "json_serialize",
  "json_table",
  "json_value",
  "lateral",
  "leading",
  "least",
  "left",
  "like",
  "limit",
  "localtime",
  "localtimestamp",
  "merge_action",
  "national",
  "natural",
  "nchar",
  "none",
  "normalize",
  "not",
  "notnull",
  "null",
  "nullif",
  "numeric",
  "offset",
  "on",
  "only",
  "or",
  "order",
  "out",
  "outer",
  "overlaps",
  "overlay",
  "placing",
  "position",
  "precision",
  "primary",
  "real",
  "references",
  "returning",
  "right",
  "row",
  "select",
  "session_user",
  "setof",
  "similar",
  "smallint",
  "some",
  "substring",
  "symmetric",
  "system_user",
  "table",
  "tablesample",
  "then",
  "time",
  "timestamp",
  "to",
  "trailing",
  "treat",
  "trim",
  "true",
  "union",
  "unique",
  "user",
  "using",
  "values",
  "varchar",
  "variadic",
  "verbose",
  "when",
  "where",
  "window",
  "with",
  "xmlattributes",
  "xmlconcat",
  "xmlelement",
  "xmlexists",
  "xmlforest",
  "xmlnamespaces",
  "xmlparse",
  "xmlpi",
  "xmlroot",
  "xmlserialize",
  "xmltable",
]);

// Every keyword that may appear in a PL/pgSQL function body — the union
// of the SQL kwlist and the PL/pgSQL reserved + unreserved kwlists. Used
// by case-folding rules that walk plpgsql bodies; lower-cased here so
// callers can compare with .toLowerCase() lookup.
// Keywords PostgreSQL refuses as identifiers in any position —
// `RESERVED_KEYWORD` from kwlist.h plus the PL/pgSQL reserved kwlist.
// Case-folding rules that walk source text without full positional
// context must only touch this set, because UNRESERVED / COL_NAME /
// TYPE_FUNC_NAME keywords (`role`, `date`, `value`, `name`, …) can
// legitimately be column / function names and case-folding them would
// corrupt the SQL.
export const PLPGSQL_RESERVED_KEYWORDS: ReadonlySet<string> = new Set([
  "all",
  "analyse",
  "analyze",
  "and",
  "any",
  "array",
  "as",
  "asc",
  "asymmetric",
  "begin",
  "both",
  "by",
  "case",
  "cast",
  "check",
  "collate",
  "column",
  "constraint",
  "create",
  "current_catalog",
  "current_date",
  "current_role",
  "current_time",
  "current_timestamp",
  "current_user",
  "declare",
  "default",
  "deferrable",
  "desc",
  "distinct",
  "do",
  "else",
  "end",
  "except",
  "execute",
  "false",
  "fetch",
  "for",
  "foreach",
  "foreign",
  "from",
  "grant",
  "group",
  "having",
  "if",
  "in",
  "initially",
  "intersect",
  "into",
  "lateral",
  "leading",
  "limit",
  "localtime",
  "localtimestamp",
  "loop",
  "not",
  "null",
  "offset",
  "on",
  "only",
  "or",
  "order",
  "placing",
  "primary",
  "references",
  "returning",
  "select",
  "session_user",
  "some",
  "strict",
  "symmetric",
  "system_user",
  "table",
  "then",
  "to",
  "trailing",
  "true",
  "union",
  "unique",
  "user",
  "using",
  "variadic",
  "when",
  "where",
  "while",
  "window",
  "with",
]);
